import React, { FC } from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';
import StockedPartTag from '../parts_index_page/StockedPartTag';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Typography } from 'antd';
import { TagEntityType, TagSelector, TagDisplay } from '../TagSystem';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const { Text } = Typography;

require('./PartRowDisplay.less');

export const getPartNumberText = (part) => (
	<span>
		{nullSafeGet('partNumber', part) ? <span>Part #{part.partNumber}</span> : null}
		{nullSafeGet('aliasPartId', part) ? (
			<span className={part.partNumber ? 'ml-4' : ''}>Alias Part #{part.aliasPartId}</span>
		) : null}
	</span>
);

const PartRowDisplay: FC<any> = ({ part, refreshParts, ...props }) => {
	const previewImage =
		part.images && part.images.length > 0
			? part.images.map((locImg) => {
					const [imgFileId, imgFileName] = locImg.split('/');
					return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800);
			  })[0]
			: null;

	return (
		<div className="partRowDisplay group" style={{ justifyContent: 'space-between' }} {...props}>
			<div className="partRowDisplay">
				<div style={{ marginRight: 24 }}>
					{previewImage ? (
						<FlexibleImageAvatar
							displayName={part.name}
							showPopover={false}
							popoverText={part.name}
							squareMode={true}
							width="120px"
							height="80px"
							imageUrl={previewImage}
						/>
					) : (
						<FlexibleImageAvatar
							displayName={part.name}
							showPopover={false}
							popoverText={part.name}
							squareMode={true}
							width="120px"
							height="80px"
							imageUrl="https://s3.amazonaws.com/emptor-data-assets/images/empty-state/icons8-screw-filled-100.png"
						/>
					)}
				</div>
				<div>
					<div className="partRowDisplay__rowTitle flex items-center">
						<div className="min-w-0 flex-shrink" style={{ maxWidth: 'fit-content' }}>
							<Ellipsis
								tooltip={true}
								lines={1}
								className={'pb-0.5'}
								style={{ lineHeight: '24px' }}
							>
								{part.name ? part.name.trim() : ''}
							</Ellipsis>
						</div>
						<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_PARTS_AND_EQUIPMENTS}>
							<div className="ml-2 hidden shrink-0 group-hover:inline-flex">
								<TagSelector
									entityType={TagEntityType.PART}
									entityId={part.id}
									associatedTagIds={nullSafeGetOrElse('tagIds', part, [])}
									refreshTable={refreshParts}
								/>
							</div>
						</AccessPermissionChecker>
					</div>
					<div className="partRowDisplay__rowSubtitle flex flex-col">
						<Ellipsis tooltip={true} lines={1} fullWidthRecognition>
							{getPartNumberText(part)}
						</Ellipsis>
						{nullSafeGet('glCode', part) ? <div>GL Code: {nullSafeGet('glCode', part)}</div> : null}
						{part.description && (
							<Ellipsis tooltip={true} length={80}>
								{part.description}
							</Ellipsis>
						)}
						<div className="mt-2 flex flex-row items-center">
							<StockedPartTag isStocked={part.isStocked} />
							{part.isActive ? null : (
								<div className="ml-4">
									<Text className={'mr-1'} type={'danger'}>
										Inactive
									</Text>
								</div>
							)}
							{nullSafeGetOrElse('tags', part, []).map((tag) => (
								<div className="ml-4" key={tag.id}>
									<TagDisplay tag={tag} />
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PartRowDisplay;
